import styled from "styled-components";
import { theme }  from "@theme";

export const StoryWrapper = styled.div`
  display: flex;
  gap: 10px;

  .story-image {
    position: relative;
  }

  .story-image .story-current-image {
    width: 322px;
    height: 440px;
  }
  
  .story-image .story-current-image::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 111px;
    background: linear-gradient(180deg, rgba(89, 78, 71, 0) 0%, #594E47 100%);

    border-radius: 0 0 8px 8px;
  }

   > div {
    border-radius: 8px;

    .light {
      position: absolute;
      bottom: 13px;
      left: 13px;
      padding: 7px 15px;
      background: rgba(178, 155, 132, 0.3);
      backdrop-filter: blur(2px);
      border-radius: 6px;
      cursor: pointer;
    }

    .light-peoples {
      display: flex;
      position: absolute;
      bottom: 13px;
      right: 25px;

      .light-count {
        background: rgba(178, 155, 132, 0.3);
        border-radius: 6px;
        backdrop-filter: blur(2px);
        padding: 8px;
        color: #fff;
        margin-left: 21px;
        margin-right: -18px;
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: ${theme.breakpoints.xlg}) {
    .story-image .story-current-image{
      width: 280px;
    } 
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    margin: 0 !important;
    > div {
      width: 100% !important;
    }
  }
  
  @media screen and (max-width: ${theme.breakpoints.md}) {
    flex-direction: column;
    align-items: center;
    margin: auto;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    .story-image .story-current-image {
      width: 100%;
      height: auto;
    }
  }
`;

export const StoryImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  position: relative;
`;

export const Candle = styled.div`
  display: flex;
  align-items: center;
  padding: 2px;
  border: 1px solid #e4d7cd;
  border-radius: 999px;
  gap: 6px;
  color: #4f473a;

  span {
    color: rgba(79, 71, 58, 0.4);
    margin-right: 10px;
  }
`;

export const Cryonized = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  position: absolute !important;
  top: 13px;
  left: 13px;
  border-radius: 6px;
  border: 1px solid rgba(88, 189, 255, 0.50);
  background: #71B8E6;
  box-shadow: 0px 10px 6px 0px rgba(255, 255, 255, 0.30) inset;
  padding: 7px 10px;
  color: #ffffff;
  width: 139px;
  height: 32px;

  img {
    width: 18px !important;
    height: 18px !important;
  }
`;

export const CandleAllTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px;
  border: 1px solid #e4d7cd;
  border-radius: 6px;
  gap: 4px;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background: #e4d7cd;
`;

export const StoryParent = styled.div`
  padding: 12px 24px 24px 24px;
  border: 1px solid #e4d7cd;
  border-radius: 8px;
  background: #f9f2ec;
  width: -webkit-fill-available;
  min-width: 360px;

  @media screen and (max-width: ${theme.breakpoints.xlg}) {
    min-width: 280px;
  }

  @media screen and (max-width: ${theme.breakpoints.md}) {
    min-width: 100%;
  }
`;

export const StoryOptions = styled.div`
  display: flex;
  gap: 6px;
  position: relative;

  .ant-dropdown {
    position: absolute;
  }

  .option:not(.ant-select-dropdown-hidden) {
    top: 34px !important;
    left: 114px !important;
    padding: 0;
  }
  .option ul {
    background: #fff7f1;
    width: max-content;
  }

  .option ul li span span {
    gap: 10px !important;
  }

  .options-div {
    background: #f0e5de;
    border-radius: 6px;
    width: fit-content;
    height: fit-content;
    margin-bottom: 18px;
    cursor: pointer;
    border: none;
  }

  p {
    display: flex;
    gap: 6px;
    padding: 5px;
    border-radius: 6px;
    width: fit-content;
    height: fit-content;
    cursor: pointer;
  }
`;
